"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var ObjectId = require('bson').ObjectID;
var History = /*#__PURE__*/_createClass(function History(user, action, collection, documentId, payload) {
  var inventoryId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  _classCallCheck(this, History);
  this.action = action;
  this.modifiedDate = new Date();
  this.modifiedBy = {
    userId: user.userId,
    firstName: user.firstName,
    lastName: user.lastName
  };
  this.collection = collection;
  this.payload = payload;
  var tempDocId = null;
  try {
    tempDocId = typeof documentId === 'string' ? new ObjectId(documentId) : documentId;
  } catch (e) {
    tempDocId = documentId;
  }
  this.documentId = tempDocId;
  this.inventoryId = inventoryId;
});
module.exports = History;